import { PropsWithChildren, ReactNode } from 'react';

import { Box, Divider, Link } from '@mui/material';

export interface PromotionFooterFCProps {
  strings: {
    moreDetails: string;
    termsAndConditions: string;
    omnibusDisclaimer: string;
  };
  tacLink?: string;
  text?: string;
  preText?: ReactNode;
  shouldShowOmnibusDisclaimer?: boolean;
  hideTacText?: boolean;
  hideTacLink?: boolean;
}

export const PromotionFooterFC = (props: PropsWithChildren<PromotionFooterFCProps>) => {
  const { strings, text, tacLink, preText, shouldShowOmnibusDisclaimer, hideTacLink, children } =
    props;
  return (
    <Box>
      <Box mb={3}>
        <Divider />
      </Box>
      <Box display="flex" alignItems="center" justifyContent="space-between" gap={1}>
        <Box display="flex">{children}</Box>
        <Box
          sx={{ visibility: props.hideTacText ? 'hidden' : 'visible' }}
          display="flex"
          flexDirection="column"
          gap={1}
        >
          <Box display="inline-flex" alignItems="flex-start">
            {preText}
            {text ?? strings.moreDetails}
            {!hideTacLink && (
              <>
                {' '}
                <Link target="_blank" href={tacLink} marginLeft="1px">
                  {strings.termsAndConditions}
                </Link>
              </>
            )}
          </Box>
          <Box>
            {shouldShowOmnibusDisclaimer &&
              !!strings.omnibusDisclaimer &&
              strings.omnibusDisclaimer}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
